import { downloadFile } from './utils';
import React from 'react';
// @ts-ignore
import { USBIconDownload, USBIconShow, USBIconDelete } from '@usb-shield/react-icons';

export const metadataDetails = [
  {
    title: 'Deal Name',
    key: 'metadata.dealName',
  },
  {
    title: 'Deal Number',
    key: 'metadata.dealId',
  },
  {
    title: 'Legal Entity',
    key: 'metadata.reportingEntity',
  },
];

/** @param {{ onDeleteRequest: (rows: any[]) => void }} param0 */
export const getColumns = ({ onDeleteRequest }) => [
  {
    label: 'Document Title',
    accessor: 'documentMetadata.documentName',
    sortable: true,
    style: { width: '60%' },
    cell: (row) => {
      const metadata = row.documentMetadata?.[0] || {};
      return (
        <>
          {metadata.documentName}
          <br />
          {metadata.fileNetMetadata?.fileSize}
        </>
      );
    },
  },
  {
    label: 'Uploaded Date',
    accessor: 'documentMetadata.uploadDate',
    sortable: true,
    style: { width: '20%' },
  },
  {
    label: '',
    accessor: '',

    cell: (row) => {
      const metadata = row.documentMetadata?.[0] || {};
      const enablePreview = metadata.documentName?.includes('.pdf');
      const isDeleteAllowed = sessionStorage.getItem('userrole') === 'employee' && (!sessionStorage.getItem('remote_user'));
      /** @param {string} id */
      const preview = (id) => {
        let type = 'IB';
        var url = window.location.pathname;
        var reqId = url.substring(url.lastIndexOf('/') + 1);
        window.open(
          `/document-viewer?url=` + id + `&type=` + type + `&req=` + reqId
        );
      };
      return (
        <>
          <button
            className="table-action-icon"
            onClick={async () => {
              await downloadFile({
                metadata: row.documentMetadata?.[0] || {},
              });
            }}
          >
            <USBIconDownload
              colorVariant={'brand-primary'}
              title={`Download file`}
              ariaHidden={true}
              id="add-icon"
              focusable={true}
              tabIndex={-1}
            />
          </button>
          <button
            className="table-action-icon"
            onClick={() => {
              // console.log('clicked preview');
              if (enablePreview) {
                preview(
                  row?.documentMetadata[0]?.universalMetadataId
                    ? row.documentMetadata[0].universalMetadataId
                    : row.documentMetadata[0].filenetId
                );
              } else {
                alert('Only .pdf documents can be previewed.');
              }
            }}
            disabled={false}
          >
            <USBIconShow
              colorVariant={enablePreview ? 'brand-primary' : 'grey60'}
              title={`Preview file`}
              ariaHidden={true}
              id="add-icon"
              focusable={true}
              tabIndex={-1}
              size={24}
              addClasses="action-preview-icon"
            />
          </button>
          { isDeleteAllowed && (<button
            className="table-action-icon"
            onClick={() => {
              onDeleteRequest([row?.documentMetadata?.[0] || {}]);
            }}
          >
            <USBIconDelete
              colorVariant={'brand-primary'}
              title={`Delete file`}
              ariaHidden={true}
              id="delete-icon"
              focusable={true}
              tabIndex={-1}
            />
          </button>)
          }
        </>
      );
    },
    style: { width: '15%', textAlign: 'right' },
  },
];
